import(/* webpackMode: "eager" */ "/app/app/[locale]/terms-of-use/page.tsx");
